/*
 * @Author: seven.zhang 
 * @Date: 2019-03-15 13:43:15 
 * @Last Modified by: seven.zhang
 * @Last Modified time: 2019-04-19 17:22:09
 * 
 * chartType可能类型
 * "pie"||"line_bar"||"bar"||"stackbar"||"stackbar_Horizontal"
 */
import Util from '@/utils/Util';
let dpr = Util.setDpr(); //获取设备dpr
let color = ["#DA3135","#EFC47E","#7094CB","#1EC8CA","#FF825C","#D26389","#005CAC","#2B9CA9","#CEA900","#B978A3","#FF98A8"];//图表配色

// 图表标题设置
let chartTitleSet = (title,unit='')=>{
    let titleTxt = title;
    // if(unit){
    //     titleTxt = titleTxt + '(' + unit + ')'
    // }
    return {
        text:titleTxt,
        textStyle:{
            color:'#1D2531',
            fontSize:16*dpr,
        },
        textAlign:'center',
        left:'50%',
        top:'5%',
    }
}

// 基础柱/折线/混合图
// tooitip
let baseBarTooltipSet = (obj)=>{
    return {
        trigger: 'axis',
        axisPointer: {
            type: 'line',
            label: {
                backgroundColor: '#6a7985'
            }
        },
        formatter: function(param) {
            // console.log(param)
            let title = `<span class="fs_12 c_fff">${param[0].name}</span>`
            let data=[]
            param.forEach((item,index)=>{
                let list = `<span class="fs_12 c_fff">${obj.chartData[index].name}</span>
                            <span class="fs_18" style="color:${color[index]};font-weight:bold;">${Util.formatNum(item.value)}</span>
                            <span class="fs_12 c_fff">${obj.chartData[index].unit}</span>`
                data.push(list)
            })
            
            return data.join('<br />') + '<br />'+ title
        },
    }
}
// 可能需要特殊处理的配置， 先定义基础配置，下面再根据具体种类不同进行处理
let yAxisItemSet = (obj,yMax,yMin,unit,index) => {
    let yAxisItem = {
        type: 'value',
        // name:obj.chartData[index].unit,
        nameTextStyle:{
            color:'#6B788A'
        },
        axisLabel: {
            show:true,
            color: '#6B788A'
        },
        axisLine:{
            show: true,
            lineStyle: {
                color: '#E7E9ED'
            },
        },
        axisTick:{
            show: false,
        },
        splitLine:{
            show:false,
            lineStyle:{
                color: ['#C5D0DE'],
                opacity:0.3
            }
        }
    }
    //根据type不同进行的特殊处理
    if(obj.chartType=='line_bar'){
        yAxisItem.axisLabel.show=true;
        yAxisItem.splitLine.show=true;
        yAxisItem.axisLine.show=false;
        yAxisItem = {...yAxisItem,...{
            min: yMin,
            max: yMax,
            splitNumber: 5,
            interval: Math.ceil((yMax-yMin) / 5),
        }}
    }
    if(obj.chartType=='bar'&&obj.chartData.length==1){
        yAxisItem.axisLine.show=false;
        yAxisItem.axisLabel.show=false;
    }
    
    if(obj.chartType=='stackbar_Horizontal'){
        yAxisItem.type='category'
        yAxisItem.inverse=true
        yAxisItem.data=obj.xAxisData||[]
    }

    // if(index-1>0){//超过两个维度时
        // yAxisItem.offset=65*(index-1)
    // }

    if(unit.length==3&&index==1){//出现三个维度时，隐藏第二个
        // console.log(unit[index])
        yAxisItem.axisLabel.show=false;
        yAxisItem.splitLine.show=false;
        yAxisItem.axisLine.show=false;
    }

    return yAxisItem
}
let xAxisItemSet = (obj) => {
    let xAxisItem = {
        type: 'category',
        // boundaryGap: true,
        axisLine: { //坐标轴轴线相关设置。数学上的x轴
            show: true,
            lineStyle: {
                color: '#E7E9ED'
            },
        },
        axisLabel: { //坐标轴刻度标签的相关设置
            show: true,
            color: '#ADAFB2',
            margin: 15*dpr,
            fontSize: 12 * dpr,
            // rotate:45,
        },
        axisTick: {
            show: true,
            // inside: true,
            // interval:0,//设置成 0 强制显示所有标签
            alignWithLabel:true,
            length: 8*dpr,
            lineStyle:{
                width: 1*dpr
            }
        },
        splitLine:{
            show: false,
            lineStyle:{
                color: ['#C5D0DE'],
                opacity:0.3
            }
        },
    }
    //根据type不同进行的特殊处理
    if(obj.chartType=='stackbar_Horizontal'){
        xAxisItem.type='value'
        
    }else{
        xAxisItem.data = obj.xAxisData||[]
    }

    return xAxisItem
}

export default {
    pie:(obj={})=>{
        return {
            class: 'echarts',
            option: {
                color: color,
                title: chartTitleSet(obj.title,obj.unit),
                legend:{
                    orient:'vertical',//图例列表的布局朝向
                    left: '60%',
                    top: '25%',
                    icon: "circle", 
                    itemWidth: 10*dpr,  // 设置宽度
                    itemHeight: 10*dpr, // 设置高度
                    textStyle:{
                        color:'#687586'
                    },
                    tooltip: {
                        show: true,
                        formatter(e){
                            // console.log(e,obj)
                            let name = e.name
                            let value = ''
                            obj.chartData.forEach(item=>{
                                if(item.name==name){
                                    value = item.value + obj.unit
                                }
                            })
                            return name+'：'+value
                        }
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{b}: {d}%"
                },
                series: [{
                    name: '',
                    type: 'pie',
                    // minAngle: 10,//最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
                    avoidLabelOverlap: true, //是否启用防止标签重叠策略
                    center: ['30%', '50%'],
                    radius: ['0', '55%'],
                    label: {
                        show: false,
                    },
                    data: obj.chartData||[],
                }]
            }
        }
    },
    basebar:(obj={})=>{
        let unit=[];//去重后的单位数组，用于Y轴的设置
        obj.chartData.forEach((item)=>{
            if(unit.indexOf(item.unit)==-1){
                unit.push(item.unit)
            }
        })

        // 设置Y轴&series
        let yAxis = [];
        let series = [];
        unit.forEach((unitItem,index)=>{
            let yData = []
            obj.chartData.forEach((item,idx)=>{
                if(unitItem==item.unit){
                    yData.push(item.value)

                    // series
                    let seriesItem = {
                        name:item.name+(item.unit&&unit.length>1?('('+ item.unit +')'):''),//有多个单位时，在图例文字后面标注
                        type:item.type,
                        yAxisIndex: index,
                        data:item.value
                    }

                    if(item.type=='line'){
                        let lineSet = {
                            symbolSize:10*dpr,
                            lineStyle: {
                                normal:{
                                    width:3*dpr,
                                }
                            },
                            // label:{
                            //     show:true,
                            //     formatter: '{c}'+item.unit,
                            //     color: '#56606F'
                            // },
                        }
                        seriesItem={...seriesItem,...lineSet}
                    }else if(item.type=='bar'){
                        let barSet = {
                            barMaxWidth: 32*dpr,
                            itemStyle: { 
                                barBorderRadius: [4*dpr,4*dpr,0,0],
                            },
                        }
                        //堆叠图
                        if(obj.chartType.indexOf('stack')!=-1){
                            barSet.stack='总量'
                            if(idx==obj.chartData.length-1){
                                if(obj.chartType=='stackbar'){
                                    barSet.itemStyle={
                                        barBorderRadius: [4*dpr,4*dpr,0,0],
                                    }
                                }else if(obj.chartType=='stackbar_Horizontal'){
                                    barSet.itemStyle={
                                        barBorderRadius: [0,4*dpr,4*dpr,0],
                                    }
                                }
                            }else{
                                barSet.itemStyle={
                                    barBorderRadius: 0,
                                }
                            }
                        }

                        // 排行图
                        if(obj.chartType=="bar"&&obj.chartData.length==1){
                            barSet.label={
                                show:true,
                                formatter: '{c}',
                                color: '#6A7789',
                                position:'top'
                            }
                        }
                        
                        seriesItem={...seriesItem,...barSet}
                    }    
                    series.push(seriesItem)
                }
            })
            let yMax = Util.calMax(yData)
            let yMin = Util.calMin(yData)
            let yItem = yAxisItemSet(obj,yMax,yMin,unit,index)
            yAxis.push(yItem)
        })

        return {
            class: 'echarts',
            option: {
                color: color,
                title: chartTitleSet(obj.title,unit.length==1?unit[0]:''),//仅有一个单位时，显示在title后面，图例文字后面不需标注
                legend:{
                    show: obj.chartData.length>1?true:false,
                    bottom: '2%',
                    itemWidth: 15*dpr,  // 设置宽度
                    itemHeight: 10*dpr, // 设置高度
                    textStyle:{
                        color:'#687586'
                    }
                },
                tooltip: baseBarTooltipSet(obj),
                grid: {
                    top: obj.chartData.length>1?'18%':'22%',
                    left: '5%',
                    right: '4%',
                    bottom: obj.chartData.length>1?'10%':'5%',
                    containLabel: true,
                },
                xAxis: [xAxisItemSet(obj)],
                yAxis: yAxis,
                series: series,
            }
        }
    },
    



    // ==================================备用===============================
    line_bar:(obj={})=>{
        // console.log(obj)
        let unit=[];//去重后的单位数组，用于Y轴的设置
        obj.chartData.forEach((item)=>{
            if(unit.indexOf(item.unit)==-1){
                unit.push(item.unit)
            }
        })

        // 设置Y轴&series
        let yAxis = [];
        let series = [];
        unit.forEach((unitItem,index)=>{
            let yData = []
            obj.chartData.forEach((item)=>{
                if(unitItem==item.unit){
                    yData.push(item.value)

                    // series
                    let seriesItem = {
                        name:item.name+(item.unit&&unit.length>1?('('+ item.unit +')'):''),//有多个单位时，在图例文字后面标注
                        type:item.type,
                        yAxisIndex: index,
                        itemStyle: { 
                            barBorderRadius: [4*dpr,4*dpr,0,0],
                        },
                        data:item.value
                    }
                    if(item.type=='line'){
                        let lineSet = {
                            symbolSize:10*dpr,
                            lineStyle: {
                                normal:{
                                    width:3*dpr,
                                }
                            },
                            label:{
                                show:true,
                                color: '#56606F'
                            },
                        }
                        seriesItem={...seriesItem,...lineSet}
                    }        
                    series.push(seriesItem)
                }
            })
            let yMax = Util.calMax(yData)
            let yItem = {
                type: 'value',
                min: 0,
                max: yMax,
                interval: Math.ceil(yMax / 5),
                axisLabel: {
                    // formatter: '{value} ml',
                    color: '#6B788A'
                },
                axisLine:{
                    show: false,
                },
                axisTick:{
                    show: false,
                },
                splitLine:{
                    lineStyle:{
                        color: ['#C5D0DE'],
                        opacity:0.3
                    }
                }
            }
            yAxis.push(yItem)
        })

        return {
            class: 'echarts',
            option: {
                color: color,
                title: chartTitleSet(obj.title,unit.length==1?unit[0]:''),//仅有一个单位时，显示在title后面，图例文字后面不需标注
                legend:{
                    show: obj.chartData.length>1?true:false,
                    bottom: '2%',
                    itemWidth: 15*dpr,  // 设置宽度
                    itemHeight: 10*dpr, // 设置高度
                    textStyle:{
                        color:'#687586'
                    }
                },
                tooltip: baseBarTooltipSet(obj),
                grid: {
                    top: '18%',
                    left: '1%',
                    right: '1%',
                    bottom: obj.chartData.length>1?'10%':'5%',
                    containLabel: true,
                },
                xAxis: [{
                    type: 'category',
                    // boundaryGap: true,
                    axisLine: { //坐标轴轴线相关设置。数学上的x轴
                        show: true,
                        lineStyle: {
                            color: '#E7E9ED'
                        },
                    },
                    axisLabel: { //坐标轴刻度标签的相关设置
                        color: '#ADAFB2',
                        margin: 15*dpr,
                        fontSize: 12 * dpr,
                    },
                    axisTick: {
                        show: true,
                        // inside: true,
                        // interval:0,//设置成 0 强制显示所有标签
                        alignWithLabel:true,
                        length: 8*dpr,
                        lineStyle:{
                            width: 1*dpr
                        }
                    },
                    data: obj.xAxisData||[],
                }],
                yAxis: yAxis,
                series: series,
            }
        }
    },
    singlebar:(obj={})=>{
        return {
            class: 'echarts',
            option: {
                color: color,
                title: chartTitleSet('2019年全国重点70城全装修建面TOP10','万㎡'),
                grid: {
                    top: '18%',
                    left: '1%',
                    right: '1%',
                    bottom: '5%',
                    containLabel: true,
                    ...obj.grid
                },
                xAxis: [{
                    type: 'category',
                    // boundaryGap: true,
                    axisLine: { //坐标轴轴线相关设置。数学上的x轴
                        show: true,
                        lineStyle: {
                            color: '#E7E9ED'
                        },
                    },
                    axisLabel: { //坐标轴刻度标签的相关设置
                        color: '#ADAFB2',
                        margin: 15*dpr,
                        fontSize: 12 * dpr,
                    },
                    axisTick: {
                        show: true,
                        // inside: true,
                        // interval:0,//设置成 0 强制显示所有标签
                        alignWithLabel:true,
                        length: 8*dpr,
                        lineStyle:{
                            width: 1*dpr
                        }
                    },
                    data: ['武汉','郑州','广州','西安','沈阳','佛山'],
                    ...obj.xAxis
                }],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            show: false,
                        },
                        axisLine:{
                            show: false,
                        },
                        axisTick:{
                            show: false,
                        },
                        splitLine:{
                            show: false,
                            lineStyle:{
                                color: ['#C5D0DE'],
                                opacity:0.3
                            }
                        }
                    },
                ],
                series: [{
                    name:'新开盘建面',
                    type:'bar',
                    barMaxWidth: 32*dpr,
                    label:{
                        show:true,
                        color: '#6A7789',
                        position:'top'
                    },
                    itemStyle: { 
                        barBorderRadius: [4*dpr,4*dpr,0,0],
                    },
                    data:[2.0, 4.9, 7.0, 23.2, 25.6,18]
                }]
            }
        }
    },
    stackBar:(obj={})=>{
        return {
            class: 'echarts',
            option: {
                color: color,
                title: chartTitleSet('2019年全国重点70城全装修预证建面/户数占比','%'),
                grid: {
                    top: '18%',
                    left: '1%',
                    right: '1%',
                    bottom: '10%',
                    containLabel: true,
                    ...obj.grid
                },
                legend:{
                    bottom: '2%',
                    itemWidth: 15*dpr,  // 设置宽度
                    itemHeight: 10*dpr, // 设置高度
                    textStyle:{
                        color:'#687586'
                    }
                },
                xAxis: [{
                    type: 'category',
                    // boundaryGap: true,
                    axisLine: { //坐标轴轴线相关设置。数学上的x轴
                        show: true,
                        lineStyle: {
                            color: '#E7E9ED'
                        },
                    },
                    axisLabel: { //坐标轴刻度标签的相关设置
                        color: '#ADAFB2',
                        margin: 15*dpr,
                        fontSize: 12 * dpr,
                    },
                    axisTick: {
                        show: true,
                        // inside: true,
                        // interval:0,//设置成 0 强制显示所有标签
                        alignWithLabel:true,
                        length: 8*dpr,
                        lineStyle:{
                            width: 1*dpr
                        }
                    },
                    splitLine:{
                        show: false,
                        lineStyle:{
                            color: ['#C5D0DE'],
                            opacity:0.3
                        }
                    },
                    data: ['碧桂园','中国恒大','雅居乐','中海地产','绿地控股'],
                    ...obj.xAxis
                }],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            // show: true,
                            color: '#ADAFB2',
                            margin: 15*dpr,
                            fontSize: 12 * dpr,
                        },
                        axisLine:{
                            show: true,
                            lineStyle:{
                                color: '#E7E9ED',
                            }
                        },
                        axisTick:{
                            show: false,
                        },
                        splitLine:{
                            show: false,
                            lineStyle:{
                                color: ['#C5D0DE'],
                                opacity:0.3
                            }
                        },                        
                    },
                ],
                series: [
                    {
                        name:'绿地控股',
                        type:'bar',
                        stack:'总量',
                        barMaxWidth: 32*dpr,
                        itemStyle: { 
                            // barBorderRadius: [4*dpr,4*dpr,0,0],
                        },
                        data:[14,6,9,32,5]
                    },
                    {
                        name:'全装修未拿证建面',
                        type:'bar',
                        stack:'总量',
                        barMaxWidth: 32*dpr,
                        itemStyle: { 
                            barBorderRadius: [4*dpr,4*dpr,0,0],
                        },
                        data:[4, 1.9, 19, 2.1, 12]
                    },
                ]
            }
        }
    },
    // 横向堆叠柱状图
    stackBarHorizontal:(obj={})=>{
        return {
            class: 'echarts',
            option: {
                color: color,
                title: chartTitleSet('2019年全国重点70城全装修预证建面/户数占比','%'),
                grid: {
                    top: '18%',
                    left: '1%',
                    right: '1%',
                    bottom: '10%',
                    containLabel: true,
                    ...obj.grid
                },
                legend:{
                    // orient:'vertical',//图例列表的布局朝向
                    // left: '60%',
                    bottom: '2%',
                    // icon: "circle", 
                    itemWidth: 15*dpr,  // 设置宽度
                    itemHeight: 10*dpr, // 设置高度
                    // formatter: function (param,index) {
                    //     console.log(param,index)
                    //     // return 'Legend ' + name;
                    // }
                    textStyle:{
                        color:'#687586'
                    }
                },
                xAxis: [{
                    type: 'value',
                    // boundaryGap: true,
                    axisLine: { //坐标轴轴线相关设置。数学上的x轴
                        show: true,
                        lineStyle: {
                            color: '#E7E9ED'
                        },
                    },
                    axisLabel: { //坐标轴刻度标签的相关设置
                        color: '#ADAFB2',
                        margin: 15*dpr,
                        fontSize: 12 * dpr,
                    },
                    axisTick: {
                        show: true,
                        // inside: true,
                        // interval:0,//设置成 0 强制显示所有标签
                        alignWithLabel:true,
                        length: 8*dpr,
                        lineStyle:{
                            width: 1*dpr
                        }
                    },
                    splitLine:{
                        show: false,
                        lineStyle:{
                            color: ['#C5D0DE'],
                            opacity:0.3
                        }
                    },
                    ...obj.xAxis
                }],
                yAxis: [
                    {
                        type: 'category',
                        axisLabel: {
                            // show: true,
                            color: '#ADAFB2',
                            margin: 15*dpr,
                            fontSize: 12 * dpr,
                        },
                        axisLine:{
                            show: true,
                            lineStyle:{
                                color: '#E7E9ED',
                            }
                        },
                        axisTick:{
                            show: false,
                        },
                        splitLine:{
                            show: false,
                            lineStyle:{
                                color: ['#C5D0DE'],
                                opacity:0.3
                            }
                        },
                        data: ['全装修预证建面','全装修预证户数'],
                    },
                ],
                series: [
                    {
                        name:'一线',
                        type:'bar',
                        stack:'总量',
                        barMaxWidth: 32*dpr,
                        itemStyle: { 
                            // barBorderRadius: [0,4*dpr,4*dpr,0],
                        },
                        data:[2.0, 4.9]
                    },
                    {
                        name:'二线',
                        type:'bar',
                        stack:'总量',
                        barMaxWidth: 32*dpr,
                        itemStyle: { 
                            // barBorderRadius: [0,4*dpr,4*dpr,0],
                        },
                        data:[3.0, 21.2]
                    },
                    {
                        name:'三四线',
                        type:'bar',
                        stack:'总量',
                        barMaxWidth: 32*dpr,
                        itemStyle: { 
                            barBorderRadius: [0,4*dpr,4*dpr,0],
                        },
                        data:[4, 1.9]
                    },
                ]
            }
        }
    },
}